import React from 'react';
import { Alert } from 'react-bootstrap';
import '../AlertWithUrl.css'; // Import a custom CSS file for additional styling if needed

function AlertWithUrl({ message, messageId, typeOfMessage, target, onClose }) {
    const fullUrl = `https://ccip.chain.link/msg/${messageId}`;

    return (
        <Alert variant="dark" onClose={onClose} dismissible className="custom-alert">
            <p>{message}</p>
            <p>
                Please visit <a href={fullUrl} target="_blank" rel="noopener noreferrer">{fullUrl}</a> to check the cross-chain {typeOfMessage} status of your {target}.
            </p>
        </Alert>
    );
}

export default AlertWithUrl;
